import ApiService from "./ApiService";
import queryString from "query-string";

export async function apiCustomerRegister(data) {
  return ApiService.fetchData({
    url: `Customer/Register`,
    method: "post",
    data,
  });
}

export async function apiCustomerGetCodeWithPhone(data) {
  return ApiService.fetchData({
    url: `Customer/SendCodeByPhone?${queryString.stringify(data, {
      skipNull: true,
    })}`,
    method: "post",
  });
}

export async function apiCustomerLoginWithPhoneByCode(data) {
  return ApiService.fetchData({
    url: `Customer/LoginWithPhoneByCode?${queryString.stringify(data, {
      skipNull: true,
    })}`,
    method: "post",
  });
}

export async function apiGetCustomerDetail(token) {
  return ApiService.fetchData({
    url: `Customer/WhoAmI`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    method: "get",
  });
}

export async function apiGetCode() {
  return ApiService.fetchData({
    url: `KitchenTerminal/GetCode`,
    method: "get",
  });
}

export async function apiLogin(data) {
  return ApiService.fetchData({
    url: `KitchenTerminal/QueryCode?code=${data}`,
    method: "get",
  });
}
